<template>
    <div class="article-title-head">
        <!-- category -->
        <h3 class="article-title-head__category"
            :class="[ options.color ]"
            v-html="options.category"
        ></h3>

        <!-- phrase -->
        <h2 class="article-title-head__phrase">
            <span v-html=" '«&nbsp;' + options.phrase + '&nbsp;»'"></span>
        </h2>

        <!-- author & from-to -->
        <p class="article-title-head__author"
           :class="[ options.color ]"
        >
            <!-- author -->
            <span v-html="options.author">
            </span><span>
                <span v-html="options.from">
                </span>-<span v-html="options.to">
                </span>
            </span>
        </p>
    </div>
</template>

<script>
export default {
    name: "ArticleTitleHead",
    props: {
        options: null,
    }
}
</script>

<style scoped lang="scss">
.article-title-head {
    &__category {
        @apply mb-5;
        @apply text-2xl lg:text-3xl;
    }

    &__phrase {
        @apply mb-0;
        @apply text-3xl lg:text-4xl text-dodger_blue italic;
    }

    &__author {
        @apply mb-10;
        @apply text-3xl lg:text-4xl font-bold;
    }
}
</style>
